module.exports = __webpack_public_path__ + "images/42f28e23.www_7_kor.png";


//////////////////
// WEBPACK FOOTER
// ./images/baseintro/www_7_kor.png
// module id = 489
// module chunks = 0